export enum DebitCardProductCode {
    BANKKORT_UNG_M_BILDE = '13503',
    BANKKORT_UNG = '13504',
    BANKKORT_BARN = '13505',
    BANKKORT_UNG_M_BILDE_DEPRECATED = '13508',
    BANKKORT_UNG_DEPRECATED = '13509',
    BANKKORT_BARN_DEPRECATED = '13510',
}

export enum CreditProduct {
    AGRICARD_ANSATT = 44501,
    AGRICARD_BEDRIFT = 44901,
    AGRICARD_DIGITAL_REISEKORT = 45001,
    AGRICARD_PRIVAT = 44401,
    EIKA_ANSATT = 44201,
    EIKA_ANSATT_DIREKTE = 44202,
    LOKALBANK_ANSATT = 44701,
    LOKALBANK_BEDRIFT = 47602,
    LOKALBANK_PRIVAT = 44601,
    NAF_XTRA = 44301,
}
